import React, { useEffect, useState } from 'react'
import StateSelect from '../../Components/common/stateList.js'
import DistrictSelect from '../../Components/common/districtList.js';
import { districtListApi } from '../../Utils/APIs/districtAPI.js';
import { departmentListApi } from '../../Utils/APIs/departmentAPI.js';
import { ProductListAPI } from '../../Utils/APIs/productListAPI.js'
import DepartmentSelect from '../../Components/common/departmentList.js';
import ProductSelect from '../../Components/common/productList.js';
import { getCookie } from '../../Utils/cookies.js';
import { insertData } from '../../Utils/APIs/commonInsertAPI.js';
import { useNavigate } from 'react-router-dom';
import CommonDropdownWithAnotherUrl from '../../Components/common/commonDropDownWithAnotherUrl.js';

const Index = () => {
    const Navigate = useNavigate();
    useEffect(() => {
        const token = getCookie('token');
        if (!token) {
            Navigate('/');
        }
    }, [Navigate]);
    const [saralId, setSaralId] = useState("");
    const [farmerName, setFarmer] = useState("");
    const [fatherOrHusbandName, setFather] = useState("");
    const [contact, setContact] = useState("");
    const [ longitude, setLongitude ] = useState('');
    const [ latitude, setLatitude ] = useState('');
    const [ state, setSelectedState] = useState("");
    const [district, setDistrict] = useState("");
    const [districtList, setDistrictList] = useState([]);
    const [companyName, setCompanyName] = useState('')
    const [sanction, setSelectedSanction] = useState('');

    
    

    const handleStateChange = (stateId) => {
        setSelectedState(stateId);
    };
    const handleDistrictChange = (district) => {
        setDistrict(district);
    }
    useEffect(() => {
        if (state !== "") districtListApi(state.split('_')[1], setDistrictList);
    }, [state]);

    const [departmentList, setDepartmentList] = useState([]);
    const [department, setDepartment] = useState();
    const [departmentId, setDepartmentId] = useState("");
    const [ pumpHead, setPumpHead ] = useState('');
    const [ workOrderNumber, setWorkOrderNumber ] = useState('');
    const [ workOrderDate, setWorkOrderDate ] = useState('');
    const [ workOrderQuantity, setWorkOrderQuantity ] = useState('');


    const handleDepartmentChange = (department) => {
        const breakDepartment = department.split("-");
        setDepartmentId(breakDepartment[1]);
        setDepartment(breakDepartment[0]);
    }

    useEffect(() => {
        if (state !== "") departmentListApi(state.split('_')[1], setDepartmentList);
    }, [state]);

    const [productList, setProductList] = useState([]);
    const [product, setProduct] = useState("");
    
    //my change 
    const [HP, setHP]=useState("");
    const[AC_DC, setAC_DC]=useState(" ");
    const [ pump_type, setPumpType ] = useState('');

    const handleProductChange = (product) => {
        const breakProduct = product.split("%");
        setProduct(breakProduct[0])
    }
    useEffect(() => {
        if (departmentId !== "") ProductListAPI(departmentId, setProductList);
    }, [departmentId]);
    const [block, setBlock] = useState("");
    const [gramPanchayat, setGramPanchayat] = useState("");
    const [village, setVillage] = useState("");
    const [pin, setPin] = useState("");
    const [address, setAddress] = useState("");
    const [installationDate, setInstallationDate] = useState("");
    // const [ formStatus, setFormStatus ] = useState('');
    const farmerRegister = (e) => {
        e.preventDefault();
        const formData = {
            saralId, 
            farmerName, 
            fatherOrHusbandName, 
            contact, 
            state: state.split('_')[0],
            longitude, latitude,
            district,
            companyName: companyName.split('_')[1], 
            sanction: sanction.split('_')[1],
            department,
            product, 
            block, gramPanchayat,
            village, pin, address, pump_type, HP, AC_DC, installationDate,
            pumpHead, workOrderDate, workOrderNumber, workOrderQuantity,
        }

        console.log(formData);

        insertData(`farmer/addFarmer`, null, { ...formData, newReg: true }).then((status) => {
            if(!status){
                alert('Something went wrong');
            }
            else{
                alert('Form Submitted Successfully');
            }
        });
    }
    return (
        <>
            <div className="w-auto flex flex-col">
                <div className="mainHeading">
                    <h1 className='text-3xl font-semibold tracking-widest text-center p-2 bg-gray-50  rounded-lg'>F<span className='text-lg'>ARMER</span> R<span className='text-lg'>EGISTRATION</span></h1>
                </div>
                <div className="formField overflow-auto -z-0">
                    <form onSubmit={farmerRegister}>
                        <div className="grid gap-3 m-6 md:grid-cols-4">
                            <div>
                                <label for="first_name" className="block mb-2 text-sm font-medium text-gray-900 ">Saral ID<span className='text-red-500 fixed h-3'>*</span></label>
                                <input type="text" id="first_name" onChange={(e) => { setSaralId(e.target.value) }} value={saralId} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5 dark:bg-gray-700 " placeholder="Saral Id" required />
                            </div>
                            <div>
                                <label for="last_name" className="block mb-2 text-sm font-medium text-gray-900 ">Farmer name<span className='text-red-500 fixed h-3'>*</span></label>
                                <input type="text" id="last_name" onChange={(e) => { setFarmer(e.target.value) }} value={farmerName} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700  dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Farmer name" required />
                            </div>
                            <div>
                                <label for="company" className="block mb-2 text-sm font-medium text-gray-900 ">Father name<span className='text-red-500 fixed h-3'>*</span></label>
                                <input type="text" id="company" onChange={(e) => { setFather(e.target.value) }} value={fatherOrHusbandName} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700  dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Father name" required />
                            </div>
                            <div>
                                <label for="phone" className="block mb-2 text-sm font-medium text-gray-900 ">Contact number<span className='text-red-500 fixed h-3'>*</span></label>
                                <input type="tel" id="phone" onChange={(e) => { setContact(e.target.value) }} value={contact} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700  dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="123-45-678" required />
                            </div>
                            <div>
                                <label for="long" className="block mb-2 text-sm font-medium text-gray-900 ">Initial Longitude<span className='text-red-500 fixed h-3'>*</span></label>
                                <input type="text" id="long" onChange= {(e) => setLongitude(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700  dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Longitude" required />
                            </div>
                            <div>
                                <label for="lat" className="block mb-2 text-sm font-medium text-gray-900 ">Initial Latitude<span className='text-red-500 fixed h-3'>*</span></label>
                                <input type="text" id="lat" onChange= {(e) => setLatitude(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700  dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Latitude" required />
                            </div>
                            <div>
                                <label for="Company Name" className="block mb-2 text-sm font-medium text-gray-900 ">Company Name<span className='text-red-500 fixed h-3'>*</span></label>
                                <CommonDropdownWithAnotherUrl
                                    label='Company Name'
                                    Api_path={`${process.env.REACT_APP_API_URL}/common/showCompany`}
                                    value={companyName}
                                    onChange={setCompanyName}
                                />
                            </div>
                            <div>
                                <label for="Select Sanction" className="block mb-2 text-sm font-medium text-gray-900 ">Sanction<span className='text-red-500 fixed h-3'>*</span></label>
                                <CommonDropdownWithAnotherUrl
                                    label='Select Sanction'
                                    Api_path={`${process.env.REACT_APP_API_URL}/common/showSanction`}
                                    value={sanction}
                                    onChange={setSelectedSanction}
                                />
                            </div>
                            <div>
                                <label for="state" className="block mb-2 text-sm font-medium text-gray-900 ">State<span className='text-red-500 fixed h-3'>*</span></label>
                                <StateSelect value={state} onChange={handleStateChange} />
                            </div>
                            <div>
                                <label for="state" className="block mb-2 text-sm font-medium text-gray-900 ">District<span className='text-red-500 fixed h-3'>*</span></label>
                                <DistrictSelect districtListData={districtList} value={district} onChange={handleDistrictChange} />
                            </div>
                            <div>
                                <label for="department" className="block mb-2 text-sm font-medium text-gray-900 ">Department<span className='text-red-500 fixed h-3'>*</span></label>
                                <DepartmentSelect departmentListData={departmentList} value={department} onChange={handleDepartmentChange} />
                            </div>
                            <div>
                                <label for="department" className="block mb-2 text-sm font-medium text-gray-900 ">Product<span className='text-red-500 fixed h-3'>*</span></label>
                                <ProductSelect productListData={productList} value={product} onChange={handleProductChange} />
                            </div>
                            <div>
                                <label for="block" className="block mb-2 text-sm font-medium text-gray-900 ">Block<span className='text-red-500 fixed h-3'>*</span></label>
                                <input type="text" id="block" onChange={(e) => { setBlock(e.target.value) }} value={block} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700  dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Black" required />
                            </div>
                            <div>
                                <label for="gram" className="block mb-2 text-sm font-medium text-gray-900 ">Gram Panchayat</label>
                                <input type="text" id="gram" onChange={(e) => { setGramPanchayat(e.target.value) }} value={gramPanchayat} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700  dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Gram Panchayat" required />
                            </div>
                            <div>
                                <label for="village" className="block mb-2 text-sm font-medium text-gray-900 ">Village</label>
                                <input type="text" id="village" onChange={(e) => { setVillage(e.target.value) }} value={village} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700  dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Village" required />
                            </div>
                            <div>
                                <label for="pinCode" className="block mb-2 text-sm font-medium text-gray-900 ">Pin Code<span className='text-red-500 fixed h-3'>*</span></label>
                                <input type="number" id="pinCode" onChange={(e) => { setPin(e.target.value) }} value={pin} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700  dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="123456" pattern="[0-9]{6}" required />
                            </div>
                            <div>
                                <label for="address" className="block mb-2 text-sm font-medium text-gray-900 ">Address</label>
                                <input type="text" id="address" onChange={(e) => { setAddress(e.target.value) }} value={address} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700  dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Address" required />
                            </div>
                            {/* add new input field  */}
                            <div>
                                <label for="HP" className="block mb-2 text-sm font-medium text-gray-900 ">HP </label>
                                 <select 
                                 name='HP'
                                 onChange={(e)=>{setHP(e.target.value)}}
                                 defaultValue={HP}
                                     className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700  dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                    <option value=''>-- Select the HP --</option>
                                    <option>3 HP</option>
                                    <option>5 HP</option>
                                    <option>7.5 HP</option>
                                    <option>10 HP</option>
                                 </select>
                            </div>
                            <div>
                                <label for="AC_DC" className="block mb-2 text-sm font-medium text-gray-900 ">AC/DC</label>
                                 <select 
                                  name='AC_DC'
                                  onChange={(e)=>{setAC_DC(e.target.value)}}
                                  defaultValue={AC_DC}
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700  dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                    <option value="">-- Select the AC_DC --</option>
                                    <option value='AC'>AC</option>
                                    <option value='DC'>DC</option>
                                 </select>
                            </div>
                            <div>
                                <label for="Pump_Type" className="block mb-2 text-sm font-medium text-gray-900 ">PumpType</label>
                                 <select 
                                  name='Pump_Type'
                                  onChange={(e)=>{setPumpType(e.target.value)}}
                                  defaultValue={AC_DC}
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700  dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                    <option value="">-- Select Pump Type --</option>
                                    <option value='Surface'>Surface</option>
                                    <option value='Submersible'>Submersible</option>
                                 </select>
                            </div>
                            <div>
                                <label for="InstallationDate" className="block mb-2 text-sm font-medium text-gray-900 ">Installation Date</label>
                                <input type="date" id="InstallationDate" onChange={(e) => { setInstallationDate(e.target.value) }} value={installationDate} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700  dark:focus:ring-blue-500 dark:focus:border-blue-500" required />
                            </div>
                            <div>
                                <label for="PumpHead" className="block mb-2 text-sm font-medium text-gray-900 ">Pump Head<span className='text-red-500 fixed h-3'>*</span></label>
                                <select
                                    id='PumpHead'
                                    // name='PumpHead'
                                    defaultValue={pumpHead}
                                    onChange={(e) => setPumpHead(e.target.value)}
                                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700  dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                >
                                    <option>--Select Pump Head--</option>
                                    <option>30M</option>
                                    <option>50M</option>
                                    <option>70M</option>
                                    <option>100M</option>
                                </select>
                            </div>
                            <div>
                                <label for="workOrderNumber" className="block mb-2 text-sm font-medium text-gray-900 ">WorkOrderNumber</label>
                                <input type="text" id="workOrderNumber" onChange={(e) => { setWorkOrderNumber(e.target.value) }} value={workOrderNumber} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700  dark:focus:ring-blue-500 dark:focus:border-blue-500" required />
                            </div>
                            <div>
                                <label for="workOrderQuantity" className="block mb-2 text-sm font-medium text-gray-900 ">WorkOrderQuantity</label>
                                <input type="text" id="workOrderQuantity" onChange={(e) => { setWorkOrderQuantity(e.target.value) }} value={workOrderQuantity} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700  dark:focus:ring-blue-500 dark:focus:border-blue-500" required />
                            </div>
                            <div>
                                <label for="workOrderDate" className="block mb-2 text-sm font-medium text-gray-900 ">WorkOrderDate</label>
                                <input type="date" id="workOrderDate" onChange={(e) => { setWorkOrderDate(e.target.value) }} value={workOrderDate} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700  dark:focus:ring-blue-500 dark:focus:border-blue-500" required />
                            </div>

                        </div>
                        <button type="submit" className="text-dark bg-yellow-500 ml-6 hover:bg-yellow-400 font-medium rounded-sm text-sm w-full sm:w-auto px-5 py-2.5 text-center">Submit</button>
                    </form>
                </div>
            </div>

        </>
    )
}

export default Index






